import { useContext } from "react";
import { AttendanceContext } from "@/contexts/AttendanceContext";

export function useAttendance() {
	const value = useContext(AttendanceContext);

	return value;
}
